import {Carousel, Gallery, MediaStream, ThreeSixty, ThumbnailGallery} from '@sdox/ui'
import {BlockMediaGalleryVisualizationEnum} from '@sdox/api'

import {UnsupportedType} from '../UnsupportedType'

import type {XcNwBlock_BlockMediaGalleryType_Fragment} from '@sdox/api'
import type {SlideshowProps} from '@sdox/ui'

export const BlockMediaGallery = (xcRecord: XcNwBlock_BlockMediaGalleryType_Fragment) => {
  const {mediaGalleryItems, mediaGalleryVisualization} = xcRecord
  const sources = mediaGalleryItems.map(({image}) => image.thumbnailUrl)
  const sourcesWithPlaceholder: SlideshowProps['items'] = mediaGalleryItems.map(({image, text}) => ({
    src: image.thumbnailUrl,
    placeholderSrc: image.thumbnailUrl380w,
    thumbnailSrc: image.thumbnailUrl380w,
    width: image.originalThumbnailDimensions?.width,
    height: image.originalThumbnailDimensions?.height,
    alt: image.altText ?? '',
    richText: text ?? '',
  }))

  if (mediaGalleryVisualization === BlockMediaGalleryVisualizationEnum.Thumbnails){
    return <ThumbnailGallery items={sourcesWithPlaceholder} />
  }

  if (mediaGalleryVisualization === BlockMediaGalleryVisualizationEnum.Carousel){
    return (
      <Carousel
        images={sources}
        className={'pullout-rounded-lg'}
      />
    )
  }

  if (mediaGalleryVisualization === BlockMediaGalleryVisualizationEnum.ThreeSixty){
    return (
      <ThreeSixty
        images={sources}
        className={'pullout-rounded-lg'}
      />
    )
  }

  if (mediaGalleryVisualization === BlockMediaGalleryVisualizationEnum.Gallery){
    return <Gallery items={sourcesWithPlaceholder} />
  }

  if (mediaGalleryVisualization === BlockMediaGalleryVisualizationEnum.MediaStream){
    return <MediaStream items={sourcesWithPlaceholder} />
  }
  return <UnsupportedType __typename={xcRecord.__typename} />
}
